import type { IconProps } from './types';
import './icons.css';

export default function Filter({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      width={width || 17}
      height={height || 17}
      viewBox="0 0 17 17"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      className={`icon icon-filter ${className || ''}`}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M3.167 5.443c-.84-.84-.245-2.276.942-2.276h8.782c1.187 0 1.782 1.436.942 2.276L10.5 8.776v4.391a1 1 0 0 1-1.6.8l-1.867-1.4A1.333 1.333 0 0 1 6.5 11.5V8.776L3.167 5.443ZM12.89 4.5H4.11l3.333 3.334c.25.25.39.589.39.942V11.5l1.334 1V8.776c0-.353.14-.692.39-.942L12.89 4.5Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
